import { dispatchError, dispatchLoading, dispatchSuccess } from '../utils';
import { GET_VIDEO_PORTAL, API_TIMEOUT } from '../utils/constant';

import axios from 'axios';

export const GET_LIST_VIDEO = 'GET_LIST_VIDEO';

export const getVideo = () => {
  return (dispatch) => {
    dispatchLoading(dispatch, GET_LIST_VIDEO);

    axios({
      method: 'get',
      url: GET_VIDEO_PORTAL,
      timeout: API_TIMEOUT,
    })
      .then((response) => {
        if (response.status !== 200) {
          // ERROR
          dispatchError(dispatch, GET_LIST_VIDEO, 'error');
        } else {
          //BERHASIL

          dispatchSuccess(
            dispatch,
            GET_LIST_VIDEO,
            response.data.data ? response.data.data : []
          );
        }
      })
      .catch((error) => {
        // ERROR
        dispatchError(dispatch, GET_LIST_VIDEO, error);
        alert(error);
      });
  };
};
